// zip-codes.ts
import { JmApi } from "../jm-api/jm-api";
import { DataInstance } from "./data-instance";

export interface ZipCodeData {
  plz: string;
  note: string;
  einwohner: number;
  qkm: number;
  geometry: {
    type: "MultiPolygon";
    coordinates: number[][][][];
  };
}

export class ZipCodes extends DataInstance {
  public static readonly BASE_URL =
    import.meta.env.VITE_CLEVERREACH_API_BASE_URL + "/jmapi/v1/zipcodes";

  private data: ZipCodeData;

  constructor(data: ZipCodeData) {
    super();
    this.data = data;
  }

  get currentData(): ZipCodeData {
    return this.data;
  }

  get currentId(): string | undefined {
    return this.data.plz;
  }

  set currentId(id: string | undefined) {
    if (id) {
      this.data.plz = id;
    }
  }

  static fromObject(o: any): ZipCodes | null {
    if (o.plz && o.note && o.einwohner && o.qkm && o.geometry) {
      return new ZipCodes({
        plz: o.plz,
        note: o.note,
        einwohner: o.einwohner,
        qkm: o.qkm,
        geometry: o.geometry,
      });
    } else {
      return null;
    }
  }

  static async getZipCodeData(zipCodes: string[]): Promise<ZipCodeData[]> {
    return new Promise((resolve, reject) => {
      // Change from GET to POST with JSON body
      JmApi.post(ZipCodes.BASE_URL, {
        zip_codes: zipCodes  // Send as JSON array
      })
        .then((response: any) => {
          // console.log("Raw API response:", JSON.stringify(response, null, 2));
          // Response parsing unchanged - still GeoJSON
          const zipCodeData = response.features.map((feature: any) => {
            const data: ZipCodeData = {
              plz: feature.properties.plz,
              note: feature.properties.note,
              einwohner: feature.properties.einwohner,
              qkm: feature.properties.qkm,
              geometry: feature.geometry,
            };
            // console.log("Geometry for zip code", data.plz, ":", data.geometry);
            return data;
          });
          resolve(zipCodeData);
        })
        .catch((error) => {
          console.error("Error fetching zip code data:", error);
          reject(error);
        });
    });
  }
}
